<template>
  <div
    class="custom-message-component-root"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import { CustomMessageRootComponent } from '_c/typings/model/chat/text-node';
import { pushUrl } from '@/business/chat/custom-message-util';
import { defineComponent, PropType, ref } from 'vue';


export default defineComponent({
  name: 'CustomMessageRoot',
  props: {
    attr: {
      type: Object as PropType<CustomMessageRootComponent>,
      required: true,
    },
  },
  setup(props) {
    const maxWidth = ref('380px');
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }
    return { clickHandle, maxWidth };
  },

});

</script>

<style scoped>
.custom-message-component-root {
  background-color: #f9f9f9;
  border-radius: 6px;
  width: v-bind('maxWidth');
}
</style>
